import { z } from 'zod';
import { DocumentIdSchema, IsoTimestampSchema, Sha256HashSchema, SourceItemIdSchema } from './common.js';

export const DocumentSchema = z.object({
  id: DocumentIdSchema,
  filnavn: z.string().min(1, 'Filnavn kan ikke være tomt'),
  filtype: z.string().min(1, 'Filtype kan ikke være tom'),
  hash: Sha256HashSchema,
  /** Størrelse i bytes */
  størrelse: z.number().int().nonnegative('Størrelse må være ikke-negativ'),
  createdAt: IsoTimestampSchema.optional(),
  modifiedAt: IsoTimestampSchema.optional(),
  /** Ekstrahert tekstinnhold – kan være stort */
  textContent: z.string().optional(),
  sourceItemId: SourceItemIdSchema,
  /** Referanse til fil i objektlagring (Azure Blob / S3 / MinIO) */
  storagePath: z.string().min(1, 'StoragePath kan ikke være tom'),
});

export type Document = z.infer<typeof DocumentSchema>;
